import { createRoot } from "react-dom/client";
import React from "react";
//import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import { AppContextProvider } from "context/AppContext";
import { MuiContextProvider } from "context/MuiContext";
import { AuthContextProvider } from "context/AuthContext";
import { CacheContextProvider } from "context/CacheContext";
import { CustomProvider } from "rsuite";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <CacheContextProvider>
      <AuthContextProvider>
        <CustomProvider>
          <MuiContextProvider>
            <AppContextProvider>
              <App />
            </AppContextProvider>
          </MuiContextProvider>
        </CustomProvider>
      </AuthContextProvider>
    </CacheContextProvider>
  </BrowserRouter>,
);
